import api from './api';

const annotationsService = {
  // Récupérer les annotations d'une entité
  getAnnotations: async (targetType, targetId, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/annotations/${targetType}/${targetId}?${queryString}`);
    return response.data;
  },

  // Récupérer les annotations d'un projet
  getProjectAnnotations: async (projectId, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/annotations/project/${projectId}?${queryString}`);
    return response.data;
  },

  // Créer une annotation
  createAnnotation: async (data) => {
    const response = await api.post('/annotations', data);
    return response.data;
  },

  // Mettre à jour une annotation
  updateAnnotation: async (id, data) => {
    const response = await api.put(`/annotations/${id}`, data);
    return response.data;
  },

  // Supprimer une annotation
  deleteAnnotation: async (id) => {
    const response = await api.delete(`/annotations/${id}`);
    return response.data;
  },

  // Autocomplete pour les mentions
  getMentionSuggestions: async (query) => {
    if (!query || query.length < 2) return [];
    const response = await api.get(`/annotations/mentions/suggestions?q=${encodeURIComponent(query)}`);
    return response.data;
  }
};

export default annotationsService;
